import axios from "axios";
import { baseUrlOtodisLambdaAPI } from "../config/ApiUrlConfig";

class OtodisService {
  axios = axios.create({
    baseURL: baseUrlOtodisLambdaAPI,
  });

  setToken(token) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  async getDealer(params = {}) {
    try {
      params.lite_respon = true;
      return await this.axios.get("/dealer", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async getAssignedOrder(params = {}) {
    try {

      return await this.axios.get("/order/assign-service-bureau", {
        params: {
          ...params,
        }
      });
    } catch (e) {
      throw new Error(e.response.data.message);
    }
  }

  async updateDocumentsOrderBBN(postData) {
    try {
      return await this.axios.put("/service-bureau/order/update/document-number", postData);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async uploadInvoiceBBN(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/invoice/upload", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async paymentInvoiceBBN(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/invoice/payment", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async paymentNotice(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/notice-cost", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async paymentNoticeOld(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/notice-cost/old", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async paymentProcessBill(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/process-cost", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async paymentPkbBill(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/pkb-bill", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async UploadInvoiceServiceCost(params = {}) {

    try {
      return await this.axios.post("/service-bureau/order/invoice/upload/service-cost", params);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async createQrisProgressive(payload = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/progressive/show-qr", payload);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async updatePaymentProgressive(payload = {}) {
    try {
      return await this.axios.put("/service-bureau/order/payment/progressive/update-status", payload);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async getHeldBalanceMarketing(params = {}) {
    try {
      return await this.axios.get("/service-bureau/order/payment/progressive/held-balance", {
        params: {
          ...params,
        }
      });
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

  async payProgressivebyHeldBalanceMarketing(payload = {}) {

    try {
      return await this.axios.post("/service-bureau/order/payment/progressive/held-balance", payload);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }


  async updateStatusBill(payload = {}) {

    try {
      return await this.axios.put("/service-bureau/order/payment/update-status-bill", payload);
    } catch (e) {
      const { response } = e;
      const { request, ...errorObject } = response;
      throw new Error(errorObject.data.error.message);
    }
  }

}

export const otodisService = new OtodisService();
